import Col from '@loggi/ui/components/col';
import Text from '@loggi/ui/components/text';
import icons from '@loggi/ui/components/utils/icons';
import View from '@loggi/ui/components/view';
import { privatePackageTrackerModel } from 'app.models';
import { matchModel } from 'app/app.models';
import getStatusPath from 'app/app.utils';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import UserFeedbackAlert from 'shared/alert/user-feedback-alert/user-feedback-alert.component';
import MainView from 'shared/main-view/main-view.component';
import { ADDITIONAL_RECEIVERS } from 'tracker.routes';
import ClassificationHeader from '../classification-header/classification-header.component';
import {
  FEEDBACK_ALERT_PROPS,
  RETRY_MESSAGE
} from '../classification.constants';
import ClassificationService from '../classification.service';
import {
  ADDRESS_THRESHOLD_LENGTH_TO_SHOW_FULL_ADDRESS,
  DESTINATION_TYPES,
  DESTINATION_TYPE_QUESTION_TEXT
} from './address-classification.constants';
import styles from './address-classification.styles.scss';
import CustomRadio from './custom-radio/custom-radio.component';

/* eslint-disable react/jsx-props-no-spreading */
class AddressClassificationContainer extends Component {
  constructor(props) {
    super(props);

    const classificationType = get(
      props,
      'privatePackageTracker.destinationInfo.classificationType',
      null
    );

    const classificationInfo = this._getInitialClassificationInfo(
      classificationType
    );

    const { destinationType, childrenType } = classificationInfo;

    this.state = {
      destinationType,
      childrenType,
      destinationChildren: null,
      showUserFeedbackAlert: false
    };
  }

  componentDidMount() {
    this._updateChildrenOnMount();
  }

  _getAddressFirstLine = () => {
    const firstLine = get(
      this.props,
      'privatePackageTracker.destinationInfo.firstLine',
      ''
    );

    const truncatedAddressFirstLine = firstLine
      .slice(0, ADDRESS_THRESHOLD_LENGTH_TO_SHOW_FULL_ADDRESS)
      .trim();

    return firstLine.length <= ADDRESS_THRESHOLD_LENGTH_TO_SHOW_FULL_ADDRESS
      ? firstLine
      : `${truncatedAddressFirstLine}...`;
  };

  _getInitialClassificationInfo = classificationType => {
    let classificationInfo = {
      childrenType: null
    };

    DESTINATION_TYPES.forEach(destination => {
      const { children, type } = destination;
      if (type === classificationType) {
        classificationInfo.destinationType = type;
      }
      if (children) {
        children.forEach(destinationChildren => {
          if (destinationChildren.type === classificationType) {
            classificationInfo = {
              destinationType: type,
              childrenType: destinationChildren.type
            };
          }
        });
      }
    });
    return classificationInfo;
  };

  _renderHeader = () => {
    const { history } = this.props;

    const addressFirstLine = this._getAddressFirstLine();

    const headerProps = {
      onClickBack: history.goBack,
      headerText: `O endereço ${addressFirstLine} é:`
    };

    return <ClassificationHeader {...headerProps} />;
  };

  _onClickRetry = () => {
    this.setState({ showUserFeedbackAlert: false }, () => {
      return this._onSaveClassificationType();
    });
  };

  _getDestinationChildren = () => {
    const { destinationType } = this.state;
    return DESTINATION_TYPES.find(
      item => item.type === destinationType && item.children
    );
  };

  _updateChildrenOnMount = () => {
    const destinationChildren = this._getDestinationChildren();
    if (destinationChildren) {
      this.setState({
        destinationChildren: destinationChildren.children
      });
    } else {
      this.setState({
        destinationChildren: null
      });
    }
  };

  _onChangeDestinationType = () => {
    const destinationChildren = this._getDestinationChildren();
    if (destinationChildren) {
      this.setState({
        destinationChildren: destinationChildren.children
      });
    } else {
      this._onSaveClassificationType();
    }
  };

  handleChangeDestinationType = event => {
    this.setState(
      {
        destinationType: event.target.value,
        childrenType: null
      },
      () => this._onChangeDestinationType()
    );
  };

  handleChangeChildrenDestinationType = event => {
    this.setState(
      {
        childrenType: event.target.value
      },
      () => this._onSaveClassificationType()
    );
  };

  _onSaveClassificationType = () => {
    const {
      match: {
        params: { packageId }
      }
    } = this.props;

    const { childrenType, destinationType } = this.state;

    const classificationType = childrenType || destinationType;

    const successCallback = response => this._succesMutationCallback(response);
    const failureCallback = () => this._failureMutationCallback();

    return ClassificationService.send({
      packageId,
      classificationType,
      successCallback,
      failureCallback
    });
  };

  _failureMutationCallback = () => {
    this.setState({ showUserFeedbackAlert: true });
  };

  _succesMutationCallback = response => {
    if (!response) {
      // eslint-disable-next-line no-console
      console.error(
        `success mutation callback received ${response} as response.`
      );
      return this._failureMutationCallback();
    }
    const { history } = this.props;
    const queryString = history.location.search;
    if (queryString) {
      return history.push(`${ADDITIONAL_RECEIVERS}${queryString}`);
    }
    return history.push(ADDITIONAL_RECEIVERS);
  };

  _getStatusPath() {
    const {
      match: {
        params: { packageId }
      }
    } = this.props;
    return getStatusPath(packageId);
  }

  render() {
    const { privatePackageTracker } = this.props;

    if (!privatePackageTracker) {
      return <Redirect to={this._getStatusPath()} />;
    }

    const feedbackAlertButtonProps = [
      { value: RETRY_MESSAGE, onClick: this._onClickRetry }
    ];

    const {
      destinationType,
      childrenType,
      destinationChildren,
      showUserFeedbackAlert
    } = this.state;

    return (
      <MainView className="tracker-content classificationMainView">
        {this._renderHeader()}
        <View
          flex
          flexGrow="1"
          className={styles.classificationTypes}
          scrollwrapper="scrollWrapper"
          data-testid="scroll-wrapper"
        >
          <View gutter={{ left: 'double', right: 'double', bottom: 'half' }}>
            <View
              size={12}
              gutter={{ top: 'half', bottom: 'half' }}
              flexWrap="wrap"
              justifyContent="between"
              flexDirection="column"
              className={styles.destinationType}
            >
              {DESTINATION_TYPES.map(destination => {
                const { label, type } = destination;
                return (
                  <CustomRadio
                    id={type}
                    label={label}
                    value={type}
                    onChange={this.handleChangeDestinationType}
                    isSelected={destinationType === type}
                  />
                );
              })}
              {destinationChildren && (
                /* eslint-disable-next-line react/jsx-fragments */
                <React.Fragment>
                  <Col size={12} gutter={{ top: 'normal' }}>
                    <Text bold>{DESTINATION_TYPE_QUESTION_TEXT}</Text>
                  </Col>
                  <Col size={12} className={styles.childDestination}>
                    {destinationChildren.map(childDestination => {
                      const { label, icon, type } = childDestination;
                      return (
                        <CustomRadio
                          label={label}
                          icon={icons.type[icon]}
                          id={type}
                          value={type}
                          onChange={this.handleChangeChildrenDestinationType}
                          isSelected={childrenType === type}
                        />
                      );
                    })}
                  </Col>
                </React.Fragment>
              )}
            </View>
          </View>
        </View>
        {showUserFeedbackAlert && (
          <UserFeedbackAlert
            {...FEEDBACK_ALERT_PROPS}
            buttonsProps={feedbackAlertButtonProps}
          />
        )}
      </MainView>
    );
  }
}

function mapStateToProps(state) {
  return {
    privatePackageTracker: state.data.privatePackageTracker
  };
}

AddressClassificationContainer.displayName = 'AddressClassificationContainer';

AddressClassificationContainer.propTypes = {
  privatePackageTracker: PropTypes.shape(privatePackageTrackerModel).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
    location: PropTypes.shape({
      search: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  match: PropTypes.shape(matchModel).isRequired
};

export default connect(mapStateToProps)(AddressClassificationContainer);
